import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import qs from 'query-string';
import { ROUTES, useOtpEnabled } from '@shared';
import { useGetCurrentUser } from '@entities/user';
import { AuthorizedLayout } from './authorized-layout/AuthorizedLayout';
export interface IBasicLayoutProps {
  children: React.ReactNode;
}
export const BasicLayout = ({
  children
}: IBasicLayoutProps) => {
  const {
    data: user,
    isFetching,
    isSuccess
  } = useGetCurrentUser();
  const router = useRouter();
  const {
    route,
    query,
    asPath,
    push
  } = router;
  const otpEnabled = useOtpEnabled();
  const totpVerified = isSuccess && user && (!otpEnabled || user.otpVerify);
  const unauthenticated = user?.shouldSetPassword || !totpVerified;
  useEffect(() => {
    if (isFetching || !isSuccess) {
      return;
    }
    if (otpEnabled && !user?.otpEnabled && route !== ROUTES.totp) {
      push(ROUTES.totp);
    }
    if (unauthenticated) {
      const queryString = qs.stringify(query, {
        skipEmptyString: true
      });
      push(queryString ? `${ROUTES.login}?${queryString}` : `${ROUTES.auth}?callback_url=${asPath}`);
    }
  }, [unauthenticated, isFetching, user?.otpEnabled, route, push, query, asPath, isSuccess, otpEnabled]);
  if (totpVerified) {
    return <AuthorizedLayout user={user}>{children}</AuthorizedLayout>;
  }
  return null;
};
export function getBasicLayout(page: React.ReactElement) {
  return <BasicLayout>{page}</BasicLayout>;
}